<script>
    import { Bar } from 'vue-chartjs'

    export default {
        extends: Bar,
        props: {
            chartdata: Array,
            options: Array,
            dataname: String,
            chartOptions: {
                default: () => ({
                    showAllTooltips: false
                })
            },
            displayLabels: Boolean
        },
        mounted () {
            Chart.defaults.global.legend.display = false

            this.renderChart({
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: '#FF5100',
                        data: this.options,
                        // Change options only for labels of THIS DATASET
                        datalabels: {
                            display: !!this.displayLabels,
                        },
                    }
                ],
            }, {
                responsive: true,
                maintainAspectRatio: false,
                showAllTooltips: this.chartOptions.showAllTooltips,
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            return this.dataname + ": " + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        }
                    }
                }
            })
        }
    }
</script>

<style scoped>



</style>
